import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { replay_run_from_source_url } from '@/utils/urls.ts';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import { AUTOMATION_RUNS_KEY, PROJECT_RUNS_KEY } from '@/utils/queryKeys.ts';
import { ReplayRunFromSourceRequest, Run } from '@/types/runs.ts';
import { watchRun } from '@/features/runBrowserNotifications/watchedRuns.ts';

type Props = {
  runId: string;
  replayRequest: ReplayRunFromSourceRequest;
};

const useReplayRunFromSource = (): UseMutationResult<Run, AxiosError, Props> => {
  const apiClient = useApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ runId, replayRequest }: Props) => {
      const response = await apiClient.post(replay_run_from_source_url(runId), replayRequest);
      return response.data;
    },
    onSuccess: async (run) => {
      watchRun({
        automationId: run.automation_id,
        run,
      });

      await Promise.all([
        queryClient.invalidateQueries({ queryKey: AUTOMATION_RUNS_KEY(run.automation_id) }),
        queryClient.invalidateQueries({ queryKey: PROJECT_RUNS_KEY }),
      ]);
    },
  });
};

export default useReplayRunFromSource;
